import {TMergeValues} from './definitions';

export type TZIndex = Readonly<Record<string, number>>;

export const DEFAULT_Z_INDEX = {
  background: -1,
  dropdown: 2,
  tooltip: 3,
  infoDropdown: 4,
  footer: 5,
  subHeader: 6,
  header: 7,
  drawer: 8,
  modal: 9,
  notifications: 10,
} as const satisfies TZIndex;

export const createZIndex = <TCustomZIndex extends TZIndex = TEmptyObject>(
  customZIndex?: TCustomZIndex,
) => {
  return {...DEFAULT_Z_INDEX, ...customZIndex} as [keyof TCustomZIndex] extends [never]
    ? typeof DEFAULT_Z_INDEX
    : TMergeValues<typeof DEFAULT_Z_INDEX, TCustomZIndex>;
};
